import React, { Component } from 'react'
import './Left_side.css'

export default class LeftSide extends Component {
    constructor(props) {
        super(props);
        this.id = localStorage.getItem("id");
        this.state = {
            selected_menu: 1
        }
    }

    Select_menu = (selected_menu) => {
        this.setState({ selected_menu })
        this.props.Select_menu(selected_menu)
    }

    render() {
        return (
            <div className='Left_side_container'>
                <div onClick={() => this.Select_menu(1)}
                    className={this.state.selected_menu === 1 ? 'activ' : null}>
                    <i className="fas fa-user-graduate"></i>
                    <h4>Студенты</h4>
                </div>
                <div onClick={() => this.Select_menu(2)}
                    className={this.state.selected_menu === 2 ? 'activ' : null}>
                    <i className="fas fa-user-tie"></i>
                    <h4>Сотрудники</h4>
                </div>
                {this.props.AVN_BT_report === 1 ?
                    <div onClick={() => this.Select_menu(3)}
                        className={this.state.selected_menu === 3 ? 'activ' : null}>
                        <i className="fas fa-tasks"></i>
                        <h4>Заявки на справки</h4>
                    </div> : null}
                {this.props.AVN_BT_report === 1 ?
                    <div onClick={() => this.Select_menu(4)}
                        className={this.state.selected_menu === 4 ? 'activ' : null}>
                        <i className="fas fa-scroll"></i>
                        <h4>Учет документов</h4>
                    </div> : null}
                {this.props.AVN_BT_report === 1 ?
                    <div onClick={() => this.Select_menu(5)}
                        className={this.state.selected_menu === 5 ? 'activ' : null}>
                        <i className="fas fa-cogs"></i>
                        <h4>Справочник</h4>
                    </div> : null}
                {this.props.is_admin === 1 ? (<div onClick={() => this.Select_menu(6)}
                    className={this.state.selected_menu === 6 ? 'activ' : null}>
                    <i className="fas fa-key"></i>
                    <h4>Разрешения</h4>
                </div>) : null}
                <a href='https://www.youtube.com/watch?v=FtwYaaIsFT4'
                    target="_blank"
                    rel="noreferrer"
                    className="Rukovodstvo"> <i className="fab fa-youtube"></i>Руководство для пользователя</a>
            </div>
        )
    }
}
